import axios from 'axios';
import { handleResponse } from './HelperService';

const getAllDelivery = (params, onSuccess, onError) => {
    const response = axios.get('v1/delivery', { params });
    return handleResponse(response, onSuccess, onError);
};

const getSODetail = (id, params, onSuccess, onError) => {
    const response = axios.get(`v1/delivery/detail/${id}`,{ params });
    return handleResponse(response, onSuccess, onError);
};
const getDelivery = (id, params, onSuccess, onError) => {
    const response = axios.get(`v1/delivery/${id}/detail`,{ params });
    return handleResponse(response, onSuccess, onError);
};

const createDelivery = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/delivery/create`, payload);
    return handleResponse(response, onSuccess, onError);
};

const cancelDelivery = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/delivery/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

const updatePrintCount = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/delivery/print-count/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export {getAllDelivery, getDelivery, createDelivery, getSODetail, cancelDelivery, updatePrintCount}